$(function() {
  $('.header__inline-menu details ul').css('display', 'none');
  let timer;
  $('.header__inline-menu details').hover(function() {
    clearTimeout(timer);

    $(this).attr('open', true);
    $(this).children('summary').next().stop(true).slideDown(500);
  }, function() {
    $(this).children('summary').next().stop(true).slideUp(500);

    timer = setTimeout(() => {
      $(this).attr('open', false);
    }, 5000);
  });
});


$(function() {
  $('.menu-drawer__menu details .menu-drawer__submenu').css('display', 'none');
  $('.menu-drawer__menu details summary').on('click', function(e) {
    e.preventDefault();
    if (!$(this).closest('details').prop('open')) {
      $(this).closest('details').attr('open', true);
      $(this).next('.menu-drawer__submenu').slideDown(500, function(e) {
        $(this).next('.menu-drawer__submenu').stop(false, true);
      });
    } else {
      $(this).next('.menu-drawer__submenu').slideUp(500, function(e) {
        $(this).next('.menu-drawer__submenu').stop(false, true);
      });
      setTimeout(() => {
        $(this).closest('details').attr('open', false);
      }, 500);

    }
  });
});


window.addEventListener('load', function() {
  if ($('.recently-viewed__section').length) {
    function initializeSlickIfReady() {
      var recentlyViewedItems = document.querySelectorAll(".recently-viewed .recently-viewed__section__list__item");
      var localStorageItems = JSON.parse(localStorage.getItem('recently-viewed')) || [];

      if (recentlyViewedItems.length === localStorageItems.length) {
        $(".recently-viewed__section__list").slick({
          autoplay: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          speed: 500,
          arrows: true,
          lazyLoad: "progressive",
          responsive: [{
            breakpoint: 750,
            settings: "unslick",
          }]
        });

        $(window).on("resize orientationchange", function() {
          $(".recently-viewed__section__list").slick("resize");
        });

        observer.disconnect();
      }
    }

    initializeSlickIfReady();

    var observer = new MutationObserver(function(mutations, observer) {
      initializeSlickIfReady();
    });

    var targetNode = document.querySelector(".recently-viewed");

    var config = {
      childList: true,
      subtree: true
    };

    observer.observe(targetNode, config);

    window.addEventListener('storage', function(event) {
      if (event.key === 'recently-viewed') {
        initializeSlickIfReady();
      }
    });
  }
});

$(function() {
  const header = $('.header-wrapper');

  $('a[href^="#"]:not(.modaal-btn,.forgot_password,.show-login)').on('click', function() {
    const height = header.outerHeight();
    const speed = 500;
    const href = $(this).attr("href");
    const target = $(href == "#" || href == "" ? "html" : href);
    const position = target.offset().top - height;

    $("html, body").animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });
});

$(function() {
  const hight = $('.header-wrapper').outerHeight();
  var urlHash = location.hash;
  const speed = 500;
  if (urlHash) {
    var target = $(urlHash);
    var position = target.offset().top - hight;
    $('html, body').stop().scrollTop(position - 200);
    setTimeout(function() {
      $('html, body').stop().animate({
        scrollTop: position
      }, speed, 'swing');
    }, 100);
  }
});
